<template>
  <div class="app__content">

    <section class="section">
      <div class="section__wrapper">
        <div class="section__content section__copy">
          <h2>Success</h2>

          <p>Thank you for contributing to Britain, Take A Bow.</p>
          
          <p>Your clips are now being processed and added to the database, ready to be streamed - this may take a few minutes. Please be aware that because of the random nature of the piece your clips may not always make it into the edit.</p>
          
          <router-link :to="{ name: 'view-video' }">
            <button class="button">Watch a new version</button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'upload-success',
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// upload-success.vue?0196d8a6